import axios from 'axios';
import { ActivateData, DoctorRegistData } from '../../../common/dist/common';
import { toData } from './base';

export function registUser(data: Partial<DoctorRegistData>) {
  return toData(axios.put('/api/regist', data));
}

export function activateUser(data: ActivateData) {
  return toData(axios.put('/api/regist/activate', data));
}

export default {
  registUser,
};
